module.exports = __webpack_public_path__ + "static/img/chapter.c6edf83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chapter.png
// module id = qVSG
// module chunks = 1